<ion-list mode="ios" lines="none" class="ion-no-margin list-content">
  <ng-container *ngIf="heart">
    <ion-img
      [src]="'Icons.broken-heart' | translate"
      class="img-broken-heart animated fadeIn fast"
    ></ion-img>
  </ng-container>

  <ion-card mode="ios" color="white-grad" class="card-content">
    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center no-padding-start no-padding-end item-title"
      [ngClass]="{'item-title-ios': isIos}"
    >
      <ion-label
        mode="md"
        color="darkblue"
        class="mpe-font-weight-600 youve-run-out-of-lives"
      >
        {{ 'Labels.youve-run-out-of-lives' | translate }}
      </ion-label>
    </ion-item>

    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center item-subtitle"
      [ngClass]="{'item-subtitle-ios': isIos}"
    >
      <ion-label
        mode="md"
        color="status-icon-enable"
        class="come-back-tomorrow-try-again"
      >
        {{ 'Labels.come-back-tomorrow-try-again' | translate }}
      </ion-label>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button
        size="default"
        mode="md"
        color="gradient-blue"
        class="button-enderstood"
        (click)="onClose()"
      >
        <ion-label
          mode="md"
          color="white"
          class="mpe-font-weight-600 enderstood"
        >
          {{ 'Buttons.enderstood' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>
  </ion-card>
</ion-list>
